import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

type Props = {
  date: string | Date;
};

function capitalize(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function useMeetingListItem(props: Props) {
  const dateObj = typeof props.date === 'string' ? new Date(props.date) : props.date;
  // A midnight start means no time was set: show the day only.
  const hasTime = dateObj.getHours() !== 0 || dateObj.getMinutes() !== 0;
  const time = hasTime ? format(dateObj, "HH'h'mm", { locale: fr }) : null;
  const fullDate = capitalize(format(dateObj, 'EEEE d MMMM yyyy', { locale: fr }));
  const shortDate = capitalize(format(dateObj, 'EEE d MMM yyyy', { locale: fr }));

  return {
    dayNumber: format(dateObj, 'd', { locale: fr }),
    monthAbbr: format(dateObj, 'MMM', { locale: fr }).replace('.', ''),
    fullDate,
    time,
    dateLabel: time ? `${fullDate} · ${time}` : fullDate,
    shortDateLabel: time ? `${shortDate} · ${time}` : shortDate,
    dateTime: hasTime ? dateObj.toISOString() : format(dateObj, 'yyyy-MM-dd'),
  };
}
